import type { AxiosError } from 'axios';
import { useEffect } from 'react';
import type { OsobyFyzickaOsobaDto, ResponseError } from '@gov-nx/api';
import { robPersonQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';
import { GovError } from '@gov-nx/core/app';
import { usePersonStore } from '@gov-nx/store';

interface IndividualLoaderProps {
	onError?: (error: GovError) => void;
}

interface PoIndividualDataLoad {
	isLoading: boolean;
	isError: boolean;
	individualPerson?: OsobyFyzickaOsobaDto;
	error?: AxiosError<ResponseError>;
}

export const usePoIndividualDataLoad = (
	props?: IndividualLoaderProps
): PoIndividualDataLoad => {
	const individualPerson = usePersonStore('individual');
	const setIndividualPersonData = usePersonStore('setIndividualPersonData');
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery({
		queryKey: ['osoby', 'fyzicke'],
		queryFn: async () => robPersonQuery(axiosInstance),
		onError: async (err) => {
			if (props?.onError) {
				return props.onError(new GovError(err.message));
			}
		},
		refetchOnWindowFocus: false,
		retry: 0,
		enabled: !individualPerson,
	});

	useEffect(() => {
		if (!individualPerson && query.data) {
			setIndividualPersonData(query.data);
		}
	}, [individualPerson, query.data, setIndividualPersonData]);

	return {
		individualPerson,
		isLoading: query.isInitialLoading,
		isError: query.isError,
		error: query.error ?? undefined,
	};
};
